import React, { useState, useEffect } from 'react';
import Select from "react-select";
import axios from 'axios';
import './ActiveLocations.css';
import { baseURL } from './backend_url';
import { Modal, Button, Form } from 'react-bootstrap';

function ShuttleIdentification() {
  const [companyDetail, setCompanyDetail] = useState([]);
  const [companyName, setCompanyName] = useState("Routes Car Rental");
  const [companyId, setCompanyId] = useState("690337");
  const [locationDetail, setLocationDetail] = useState([]);
  const [locationName, setLocationName] = useState("");
  const [locationId, setLocationId] = useState("");
  const [vehicleIdentifier, setVehicleIdentifier] = useState("");
  const [samsaraIdentifier, setSamsaraIdentifier] = useState("");
  const [plateNumber, setPlateNumber] = useState(""); // New state variable for Plate Number
  const [savedData, setSavedData] = useState([]);
  const [hashLocationNameVsID, setHashLocationNameVsID] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(""); // "add" or "edit"
  const [editIndex, setEditIndex] = useState(null);
  const [access, setAccess] = useState("Edit");

  // useEffect(() => {
  //   axios.get(baseURL + "/get_company_details_for_users")
  //     .then((res) => {
  //       setCompanyDetail(res.data);
  //     });
  // }, []);

  useEffect(() => {

    const companyIdTemp = '690337';
    setCompanyId(companyIdTemp);
    setSavedData([])
    const loggedInUser = sessionStorage.getItem("user_token");
    const foundUser = JSON.parse(loggedInUser);
    if ('Users' === foundUser.role) {
      setAccess(foundUser.access['ShuttleIdentification_Access Specifier']);
    }
    axios.get(baseURL + "/get_company_location/" + companyIdTemp)
      .then((res) => {
        axios.get(baseURL + "/srt_get_active_location/" + companyIdTemp.toString())
          .then((res1) => {
            axios.get(baseURL + "/srt_get_user_location/" + foundUser.userEmail)
              .then((res2) => {
                const assigned_location_hash = res2.data;
                let allTemp = res.data.res;
                let hashLocationNameId = {};
                allTemp.forEach((k) => hashLocationNameId[k.location_id] = k.location_name);
                setHashLocationNameVsID(hashLocationNameId);
                if (allTemp.length > 0) {
                  let tempArr = [];
                  for (let i = 0; i < allTemp.length; i++) {
                    if (foundUser.role === 'Users') {
                      if (res1.data[allTemp[i].location_id] === true && assigned_location_hash[allTemp[i].location_id] === true) {
                        tempArr.push(allTemp[i]);
                      }
                    }
                    else {
                      if (res1.data[allTemp[i].location_id] === true) {
                        tempArr.push(allTemp[i]);
                      }
                    }
                  }
                  setLocationDetail(tempArr);
                }
              })
          })
      });
    // }
    // }
  }, []);

  const companyNameOptions = companyDetail.map((value) => ({
    value: value.company_name, label: value.company_name
  }));

  const handleInputChangeCompanyName = (selectedOption) => {
    setCompanyName(selectedOption.value);
  };

  const handleInputChangeLocationName = (selectedOption) => {
    setLocationName(hashLocationNameVsID[selectedOption.value]);
    const locationId = selectedOption.value;
    setLocationId(locationId)

    axios.get(`${baseURL}/srt_get_vehicle_data/${locationId}`)
      .then((response) => {
        const vehicleData = response.data.vehicles || [];
        setSavedData(vehicleData);
      })
      .catch((error) => {
        console.error("Error fetching vehicle data:", error);
        setSavedData([]);  // Clear savedData in case of error
      });
  };

  const handleAddVehicle = () => {
    setModalType("add");
    setVehicleIdentifier("");
    setSamsaraIdentifier("");
    setPlateNumber(""); // Clear Plate Number field
    setShowModal(true);
  };

  const handleEdit = (index) => {
    const dataToEdit = savedData[index];
    setModalType("edit");
    setEditIndex(index);
    setVehicleIdentifier(dataToEdit.vehicleIdentifier);
    setSamsaraIdentifier(dataToEdit.samsaraIdentifier);
    setPlateNumber(dataToEdit.plateNumber); // Set Plate Number field
    setShowModal(true);
  };

  const handleSave = () => {
    const newData = { vehicleIdentifier, samsaraIdentifier, plateNumber }; // Include Plate Number
    if (modalType === "add") {
      setSavedData([...savedData, newData]);
      axios.post(`${baseURL}/srt_save_vehicle_data`, { locationId, newData })
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          console.error("Error saving vehicle data:", error);
        });
    } else if (modalType === "edit") {
      const updatedData = [...savedData];
      updatedData[editIndex] = newData;
      setSavedData(updatedData);
      axios.put(`${baseURL}/srt_update_vehicle_data`, { locationId, newData, index: editIndex })
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          console.error("Error updating vehicle data:", error);
        });
    }
    setShowModal(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleDelete = (index) => {
    const dataToDelete = savedData[index];
    const updatedData = savedData.filter((_, i) => i !== index);
    setSavedData(updatedData);
    axios.delete(`${baseURL}/srt_delete_vehicle_data`, { data: { locationId, dataToDelete } })
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error deleting vehicle data:", error);
      });
  };

  return (
    <div className="container mt-5">
      <div className="p-5 bg-light rounded shadow-sm">
        <h4 className="text-primary mb-4">Shuttle Identification</h4>
        {/* <div className="mb-4">
          <label htmlFor="company_name" className="form-label">
            Select Account
          </label>
          <Select
            value={{ value: companyName, label: companyName || "Select Account Name" }}
            inputId="company_name"
            name="company_name"
            options={companyNameOptions}
            onChange={handleInputChangeCompanyName}
          />
        </div> */}
        {companyName && (
          <>
            <div className="mb-4">
              <label htmlFor="location_name" className="form-label">
                Select Location
              </label>
              <Select
                value={{ value: locationName, label: (locationName ? locationName : "Select Location Name") }}
                inputId="location_name"
                name="location_name"
                options={locationDetail.map(location => ({
                  value: location.location_id,
                  label: `${location.location_name} - ${location.location_id.split('-')[1]}`
                }))}
                onChange={handleInputChangeLocationName}
              />
            </div>

            {locationName &&
              <>
                {access === 'Edit' &&
                  <Button className="mb-3" onClick={handleAddVehicle}>Add Vehicle</Button>
                }
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Vehicle Identifier</th>
                      <th scope="col">Samsara Identifier</th>
                      <th scope="col">Plate Number</th> {/* New column for Plate Number */}
                      {access === 'Edit' &&
                        <th scope="col">Actions</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(savedData) && savedData.map((data, index) => (
                      <tr key={index}>
                        <td>{data.vehicleIdentifier}</td>
                        <td>{data.samsaraIdentifier}</td>
                        <td>{data.plateNumber}</td> {/* New field displayed in table */}
                        {access === 'Edit' &&
                          <td>
                            <Button className='m-2' variant="primary" size="sm" onClick={() => handleEdit(index)}>Edit</Button>
                            <Button variant="danger" size="sm" onClick={() => handleDelete(index)}>Remove</Button>
                          </td>
                        }
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            }
          </>
        )}
      </div>

      {/* React Bootstrap Modal */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{modalType === "add" ? "Add Vehicle" : "Edit Vehicle"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Vehicle Identifier</Form.Label>
              <Form.Control
                type="text"
                value={vehicleIdentifier}
                onChange={(e) => setVehicleIdentifier(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Samsara Identifier</Form.Label>
              <Form.Control
                type="text"
                value={samsaraIdentifier}
                onChange={(e) => setSamsaraIdentifier(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Plate Number</Form.Label> {/* New input field for Plate Number */}
              <Form.Control
                type="text"
                value={plateNumber}
                onChange={(e) => setPlateNumber(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
          <Button variant="success" onClick={handleSave}>Save changes</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ShuttleIdentification;
